import { createId } from "@paralleldrive/cuid2";

const keyForFunnel = (funnelId: string) => `formFunnelSession:${funnelId}`;

export function readFormFunnelSessionId(funnelId: string): string | undefined {
  if (typeof window === "undefined") return undefined;
  return window.sessionStorage.getItem(keyForFunnel(funnelId)) ?? undefined;
}

export function getOrCreateFormFunnelSessionId(funnelId: string): string | undefined {
  if (typeof window === "undefined") {
    return undefined;
  }

  const key = keyForFunnel(funnelId);
  const existing = readFormFunnelSessionId(funnelId);
  if (existing) {
    return existing;
  }

  const sessionId = createId();
  window.sessionStorage.setItem(key, sessionId);
  return sessionId;
}
